import React, { Component } from 'react';
import { fireFunctions } from '../../config/firebase';
import './ContactForm.scss';
import { httpsCallable } from 'firebase/functions';

const honeyPotString = 'kdjsbfklsalkjslwq';
const honeyPotClasses = 'form-hp';

class ContactForm extends Component {

  constructor(props){
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);

    this.state = {
      name:"",
      email: "",
      [honeyPotString + 'email']: "",
      phone: "",
      socialSecurityNumber: "",
      statusOk:false,
      formError:false,
      loading:false
    }
  }

  handleFormChange(e){
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleSubmit(e){
    e.preventDefault();
    // console.log('submitting', JSON.stringify(this.state));
    this.setState({
      loading:true
    });
    
    this.sendEmail();

  }

  async sendEmail(){
    const dest = this.props.email;
    const { name, email, phone, socialSecurityNumber } = this.state;
    const objectName = this.props.objectName;
    const projectName = this.props.projectName;

    if(email.length > 0 ) {
      this.setState({
        statusOk: false,
        loading: false,
        formError: true
      })
      return false;
    }

    const details = {
      dest : dest.split(','),
      name : name,
      email : email,
      [honeyPotString + 'email'] : this.state[honeyPotString + 'email'],
      socialSecurityNumber : socialSecurityNumber,
      phone : phone,
      objectName : objectName,
      projectName : projectName,
      honeyPotString: honeyPotString
    }

      const sendEmail = httpsCallable(fireFunctions,'sendEmail');

      sendEmail(details)
        .then((result) => {
          console.log('mail sent with success');
          this.setState({
            statusOk: true,
            loading: false
          })
        })
        .catch((err) => {
          console.error(err)
          this.setState({
            statusOk: false,
            loading: false,
            formError: true
          })
        });
  }

  render() {

    return (
      <form onSubmit={this.handleSubmit} autoComplete="off" className={this.state.statusOk ? "contact-form form-submitted" : (this.state.formError ? "contact-form form-error" : "contact-form ") }>
        <h3>Fyll i formuläret nedan</h3>

        <input name="name"  type="name"  onChange={this.handleFormChange} value={this.state.name} placeholder="Namn" required />
        <input name="phone" type="tel" onChange={this.handleFormChange} value={this.state.phone} placeholder="Telefonnummer" required />
        {/* <input className={honeyPotClasses} id="input-email" autocomplete="fan" name="email" onChange={this.handleFormChange} value={this.state.email} type="email" placeholder="E-post" /> */}
        <input name={`${honeyPotString}email`} type="email" onChange={this.handleFormChange} value={this.state[honeyPotString+'email']} placeholder="E-post" required />
        <input name="socialSecurityNumber" type="text" onChange={this.handleFormChange} value={this.state.socialSecurityNumber} placeholder="Personnummer (ÅÅÅÅ-MM-DD-XXXX)" required />
        <div className="">
          <label className='text-sm checkbox-wrapper'>
            <input type="checkbox" name="gdpr" id="gdpr" required />
            <div>Jag godkänner härmed Vätterhems <a href="https://www.vatterhem.se/om-cookies/" target='_blank' rel="noreferrer">Cookiepolicy</a></div>
          </label>
        </div>
        <button className={this.state.loading ? "waiting-response" : ""} type="submit" value="Skicka">Skicka</button>
      </form>
    );
  }
}

export default ContactForm;
